import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";
import "@/i18n";

window.versions = { ...__EF_BUILD_INFO__ };

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
